import { CalculatedPlayer, PlayerRoundScore, RoundState } from "@alienheadwars/football-card-manager-model";
import { Contest } from "@alienheadwars/football-card-manager-model/dist/match/contest";
import { neutralColours } from "../../../../cards/CardColours";
import { InLine, InLineNoName, LargeCard, MediumCard } from "../../../../cards/playerCards/CardDimensions";
import { ExpandablePlayerCard } from "../../../../cards/playerCards/ExpandablePlayerCard";
import { CounterComponent } from "../../../../counter/counter";
import { AnimatedStack, SpeedDurations } from "../../../../MotionMui/MotionMui";
import { ScoreBreakdown } from "../contestDetails/ScoreBreakdown";
import { D20 } from "../dice/D20";
import { CommentaryCard } from "./CommentaryCard";
import { CommentaryTypography, CommentaryTypographyProps } from "./CommentaryTypography";
import { PlayerCardComponent } from "../../../../cards/playerCards/PlayerCard";
import { HelpOverlay } from "../../../../base/tutorial/helpOverlay/HelpOverlay";
import { localise } from "../../../../../locale/locale";



export interface ContestCommentaryComponentProps {
    roundState: RoundState;
    live: boolean
    homeTeam: string,
    contest: Contest
}


export const ContestCommentaryComponent = (props: ContestCommentaryComponentProps) => {
    const attacker = props.roundState.attackingHand[props.contest.attackingPlayerIndex].playerDetails
    const attackerScore = <ContestScore player={attacker} score={props.contest.attackingScore} live={props.live} />
    const defender = props.roundState.defendingHand[props.contest.defendingPlayerIndex].playerDetails
    const defenderScore = <ContestScore player={defender} score={props.contest.defendingScore} live={props.live} />

    const homeAttacking = props.homeTeam === props.roundState.attackingTeam ? true : false
    return <HelpOverlay helpText={localise('match.commentary.contest.help.1')} tutorialId='match.commentary.contest.help.1' textHeight="10vh">
        <HelpOverlay helpText={localise('match.commentary.contest.help.2')} tutorialId='match.commentary.contest.help.2' textHeight="10vh">
        <CommentaryCard colours={neutralColours}>
        <AnimatedStack direction='row' alignContent={'center'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
            {homeAttacking ? attackerScore : defenderScore}
            <CommentaryTypography> vs </CommentaryTypography>
            {homeAttacking ? defenderScore : attackerScore}
        </AnimatedStack>
    </CommentaryCard>
    </HelpOverlay>
    </HelpOverlay>
}

export interface ContestScoreProps {
    player: CalculatedPlayer,
    score: PlayerRoundScore,
    live: boolean,
}

export const ContestScore = (props: ContestScoreProps) => {
    const { player, score, live } = props
    const contestDetails = <ScoreBreakdown player={player} playerScore={score} dimensions={MediumCard} />
    const playerCard = <PlayerCardComponent player={player} cardDimensions={InLineNoName} />
    const attackerDice = <D20 rollTime={SpeedDurations.Slow * 1000} colours={player.colours} roll={live} fontSize={InLine.playerNameFontSize} result={score.roll} />
    const contestAdditionalProps = CommentaryTypographyProps as any
    contestAdditionalProps.sx.whiteSpace = 'nowrap'
    const modifiersSum = <CounterComponent
        initialValue={0}
        targetNumber={score.modifiers.reduce((total, modifier) => {
            return total + modifier.bonus
        }, 0)}
        animationTime={SpeedDurations.Normal * 1000}
        fontSize={InLine.playerNameFontSize}
        fontOutlineSize={InLine.heroIconOutlineWidth}
        minBoundaryNumber={20}
        maxBoundaryNumber={55}

    />
    const scoreComponent = <CounterComponent
        initialValue={score.roll}
        targetNumber={score.score}
        animationTime={SpeedDurations.Normal * 1000}
        fontSize={InLine.playerNameFontSize}
        fontOutlineSize={InLine.heroIconOutlineWidth}
        minBoundaryNumber={20}
        maxBoundaryNumber={55}

    />
    return <>
        <ExpandablePlayerCard player={player} dimensions={InLineNoName} actions={contestDetails} expandedCardSize={LargeCard} alternateChildren={playerCard} />
        <ExpandablePlayerCard player={player} dimensions={InLineNoName} actions={contestDetails} expandedCardSize={LargeCard} alternateChildren={attackerDice} />
        <ExpandablePlayerCard player={player} dimensions={InLineNoName} actions={contestDetails} expandedCardSize={LargeCard} alternateChildren='+' />
        <ExpandablePlayerCard player={player} dimensions={InLineNoName} actions={contestDetails} expandedCardSize={LargeCard} alternateChildren={modifiersSum} />
        <ExpandablePlayerCard player={player} dimensions={InLineNoName} actions={contestDetails} expandedCardSize={LargeCard} alternateChildren='=' />
        <ExpandablePlayerCard player={player} dimensions={InLineNoName} actions={contestDetails} expandedCardSize={LargeCard} alternateChildren={scoreComponent} />
    </>
}
